<template>
  <div id="contact-wrap">
    <div id="contact-area">
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdkrCphLzujj52-8znk7Bqu2EFTMmujVmG_MpDIuIl88df10w/viewform?embedded=true" width="700" height="520" frameborder="0" marginheight="0" marginwidth="0">読み込んでいます...</iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "contact-page",
  data() {
    return {};
  }
};
</script>

<style>
#contact-wrap {
  display: flex;
  z-index: -1;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}

#contact-area {
  display: inline-flex;
  width: 75%;
  height: 60%;
  justify-content: center;
  align-items: center;
}
#contact-area iframe{
  display: inline-flex;
  z-index: 5;
  width: 90%;
  height: 90%;
}

#contact-wrap,
#contact-area:before {
  background-image: url("../assets/bg_test.png");
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
}
#contact-area:before {
  content: "";
  filter: brightness(0.25) blur(5px);
  position: fixed;
  width: 75%;
  height: 60%;
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue